import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgxMaskDirective, provideNgxMask } from "ngx-mask";

// MATERIAL MODULES
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTooltipModule } from "@angular/material/tooltip";

// DIRECTIVES
import { DisableArrowsDirective } from "./directives/disable-arrows.directive";
import { DropdownTriggerForDirective } from "./directives/dropdown-trigger-for.directive";
import { GuidValidatorDirective } from "./directives/guid-validator.directive";
import { PermissionDirective } from "./directives/permission.directive";

// PIPES
import { ListValueToStringPipe } from "./pipes/list-value-to-string.pipe";
import { MomentFormatPipe } from "./pipes/moment-format.pipe";
import { PhoneNumberPipe } from "./pipes/phone-number.pipe";

// COMPONENTS
import { AdminHeaderSectionComponent } from './components/admin-header-section/admin-header-section.component';
import { AppLoadingComponent } from "./components/app-loading/app-loading.component";
import { AvailabilityIconComponent } from './components/availability-icon/availability-icon.component';
import { AvatarComponent } from "./components/avatar/avatar.component";
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { ChipListComponent } from './components/chip-list/chip-list.component';
import { ConfirmDialogComponent } from "./components/confirm-dialog/confirm-dialog.component";
import { DatePickerComponent } from "./components/date-picker/date-picker.component";
import { DbDatePickerComponent } from "./components/db-datepicker/db-datepicker.component";
import { InputMaskComponent } from "./components/db-input-mask/input-mask.component";
import { DialogFooterComponent } from "./components/dialog-footer/dialog-footer.component";
import { DialogSmsWorkerComponent } from './components/dialog-sms-worker/dialog-sms-worker.component';
import { DropdownListItemComponent } from "./components/dropdown/dropdown-list-item/dropdown-list-item.component";
import { DropdownOptionsComponent } from './components/dropdown/dropdown-options/dropdown-options.component';
import { DropdownComponent } from "./components/dropdown/dropdown.component";
import { FiltersComponent } from "./components/filters/filters.component";
import { HeaderStatsComponent } from "./components/header-stats/header-stats.component";
import { InputDialogComponent } from "./components/input-dialog/input-dialog.component";
import { InputFilesComponent } from './components/input-files/input-files.component';
import { ModalFileListComponent } from './components/modal-file-list/modal-file-list.component';
import { MultiSelectDropdownChipsComponent } from './components/multi-select-dropdown-chips/multi-select-dropdown-chips.component';
import { MultiSelectDropdownListItemComponent } from './components/multi-select-dropdown/multi-select-dropdown-list-item/multi-select-dropdown-list-item.component';
import { MultiSelectDropdownComponent } from './components/multi-select-dropdown/multi-select-dropdown.component';
import { PropertyValueComponent } from "./components/property-value/property-value.component";
import { TableCellComponent, TableComponent, TableHeaderCellComponent, TableHeaderRowComponent, TableLoadingSpinner, TableRowComponent, TableRowGroupComponent } from "./components/table/table.component";
import { TabsComponent } from './components/tabs/tabs.component';
import { TextInputComponent } from "./components/text-input/text-input.component";
import { TimeInputComponent } from "./components/time-input/time-input.component";
import { UnsavedChangesDialogComponent } from "./components/unsaved-changes-dialog/unsaved-changes-dialog.component";

const SHARED_COMPONENTS = [
  DropdownComponent,
  AvatarComponent,
  DialogFooterComponent,
  TextInputComponent,
  TableComponent,
  TableRowComponent,
  TableHeaderRowComponent,
  TableCellComponent,
  TableRowGroupComponent,
  TableHeaderCellComponent,
  TableLoadingSpinner,
  ConfirmDialogComponent,
  FiltersComponent,
  PropertyValueComponent,
  AppLoadingComponent,
  DatePickerComponent,
  TimeInputComponent,
  InputDialogComponent,
  UnsavedChangesDialogComponent,
  DropdownListItemComponent,
  MultiSelectDropdownComponent,
  InputMaskComponent,
  DbDatePickerComponent,
  ChipListComponent,
  AdminHeaderSectionComponent,
  TabsComponent,
  BreadcrumbsComponent,
  InputFilesComponent,
  ModalFileListComponent,
  MultiSelectDropdownChipsComponent,
  HeaderStatsComponent,
  AvailabilityIconComponent
];

const SHARED_DIRECTIVES = [
  PermissionDirective,
  GuidValidatorDirective,
  DropdownTriggerForDirective,
  DisableArrowsDirective
];

const SHARED_PIPES = [
  ListValueToStringPipe,
  MomentFormatPipe,
  PhoneNumberPipe
];

@NgModule({
  declarations: [
    ...SHARED_COMPONENTS,
    ...SHARED_DIRECTIVES,
    ...SHARED_PIPES,
    MultiSelectDropdownListItemComponent,
    DropdownOptionsComponent,
    DialogSmsWorkerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatTooltipModule,
    NgxMaskDirective
  ],
  providers: [
    MomentFormatPipe,
    provideNgxMask(),
  ],
  exports: [
    ...SHARED_COMPONENTS,
    ...SHARED_DIRECTIVES,
    ...SHARED_PIPES
  ]
})
export class SharedModule {}
